import type { Features, FeaturesDto } from './features.types';

export const parseFeaturesForUI = (data: FeaturesDto): Features => data ?? {};
